import { RulesType, DpaLocalAudience } from '@tt4b/ttam-enums';
import { Ref } from '@vue/composition-api';

export enum AudienceGroupKey {
  all = '-1',
  custom = '0',
  lookalike = '1'
}
export interface OptionsType {
  minRulesCount: number;
  maxRulesCount: number;
  initRules: Ref<RulesType[]>;
}

export type Validator = {
  validate: (trigger: string) => void;
};
